<template>
  <div>
    <div class="custom-card-header">
      <!-- <div class="filterButtonPosition">
        <f7-button
          fill
          class="whiteFontColor button-filter"
          panel-toggle="right"
        >
          <span class="ic-filter"></span> {{ $t('filter') }}
        </f7-button>
      </div> -->
    </div>
    <DxDataGrid
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      :auto-navigate-to-focused-row="autoFocus"
      class="custom-grid custom-grid-alerts-params"
      @contentReady="init"
      @focused-row-changed="focusedRowChanged"
      @toolbar-preparing="onToolbarPreparing($event)"
    >
      <DxScrolling mode="standard" />
      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="alertsReportsParamsTable"
      />
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <DxSearchPanel
        :visible="true"
        :width="300"
        :placeholder="$t('search')"
      />

      <DxColumn
        data-field="atc"
        :caption="$t('alert.area')"
        alignment="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="sample_code"
        :caption="$t('agronomySample.summary.sampleCode')"
        alignment="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="sample_type"
        :caption="$t('agronomySample.summary.sampleType')"
        alignment="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="farm"
        :caption="$t('foodSamples.samplingSite')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="parcel"
        :caption="$t('environmentSamples.samplingPoint')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="created_at"
        :caption="$t('alert.creationDate')"
        alignment="left"
        data-type="date"
        :format="$helpers.getDateFormat(company)"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="parameters"
        :caption="$t('alert.parameters')"
        alignment="left"
        :allow-header-filtering="false"
        cell-template="cellTemplateParams"
      />
      <DxColumn
        :buttons="editButtons"
        :fixed="true"
        fixed-position="right"
        type="buttons"
        width="90"
      />

      <template #cellTemplateParams="{ data }">
        <div style="min-width: 100px">
          {{
            data.value.flatMap((param) => param.parameter).toString()
          }}
        </div>
      </template>
    </DxDataGrid>

    <ParamsDetailsPopup v-if="showReportPopup" :details="details" />
  </div>
</template>
<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
} from 'devextreme-vue/data-grid';

import { mapActions, mapState } from 'vuex';

import notify from 'devextreme/ui/notify';
import ParamsDetailsPopup from '@/components/Alerts/Reports/DetailsPopup/Params/index.vue';
import EventBus from '@/services/event-bus';
import Helpers from '@/js/helpers';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import iconVisibility from '@/static/icons/ic_visibility.svg';
import iconTrash from '@/static/icons/ic_trash_new.svg';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    ParamsDetailsPopup,
  },
  props: {
    store: {
      type: Object,
      default: () => {},
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      editButtons: [
        {
          icon: iconVisibility,
          cssClass: 'grid-button-icon',
          onClick: this.showDetails,
        },
        {
          icon: iconTrash,
          cssClass: 'grid-button-icon',
          onClick: this.delete,
        },
      ],
      details: [],
    };
  },
  computed: {
    autoFocus() {
      return Helpers.isEmptyObject(this.params);
    },
    ...mapState('contact', ['company']),
    ...mapState('alertsParams', [
      'showReportPopup',
      'focusedReportRowKey',
    ]),
  },
  methods: {
    init(e) {
      e.component.option('focusedRowKey', this.focusedReportRowKey);
      this.changedFocused = true;
    },
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-simple-toolbar',
      };
      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'before';
        }
      });

      // Añadir el selector de agrupaciones
      toolbarItems.push({
        name: 'Filtros',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('filter'),
          icon: '././static/icons/ic_filter.svg',
          width: 115,
          elementAttr: {
            class: 'btn-filtrar',
          },
          onClick: () => {
            this.$f7.panel.open('right');
          },
        },
      });
    },
    focusedRowChanged(row) {
      if (!row.row) return;

      if (this.changedFocused) {
        if (Helpers.isEmptyObject(this.params)) {
          this.setReportFocusedRowKey(row.row.data.id);
        }
      }
    },
    applyFramework7DialogTexts() {
      if (!this.$f7) return;

      this.$f7.params.dialog.buttonCancel = this.$t('cancel');
      this.$f7.params.dialog.buttonOk = this.$t('samplesRegister.ok');
    },
    delete(data) {
      this.applyFramework7DialogTexts();
      this.$f7.dialog.confirm(
        `${this.$t('reports.deleteConfirm')}`,
        async () => {
          const { id } = data.row.data;

          try {
            notify(
              {
                message: this.$t('reports.deleting'),
                width: 450,
              },
              'info',
              2000
            );

            await this.deleteAlertReport(id);

            notify(
              {
                closeOnClick: true,
                message: this.$t('reports.deleted'),
                width: 450,
              },
              'success',
              2000
            );

            EventBus.$emit('AlertsParamsReportsPage', this.params);

            this.$f7.dialog.close();
          } catch (error) {
            this.$notifyDX(
              {
                message: this.$t(
                  this.$helpers.getFilteredErrorMessage(
                    JSON.parse(error.message).error
                  )
                ),
                width: 550,
              },
              'error',
              NOTIFY_TIME_LONG
            );
          }
        }
      );
    },
    // showDetails(e) {
    //   const { data } = e.row;
    //   this.details = data;

    //   this.setShowReportPopup(true);
    // },
    showDetails(e) {
      const { data } = e.row;
      this.$f7router.navigate('/alerts/params/reports/details', {
        props: { details: data },
      });
    },

    ...mapActions('alertsParams', [
      'setShowReportPopup',
      'deleteAlertReport',
      'setReportFocusedRowKey',
    ]),
  },
};
</script>
<style>
/* .custom-grid .dx-command-edit {
  font-size: 0;
}
.custom-grid .dx-command-edit img.dx-link-icon {
  margin-right: 16px !important;
} */

/* SOLO afecta a este grid de Alertas > Parámetros */

.custom-grid-alerts-params .dx-command-edit .dx-link-icon {
  margin-right: 12px !important; /* ajusta el valor a tu gusto */
  cursor: pointer !important;
}

/* Evitar que el último icono (la basura) tenga margen extra */
.custom-grid-alerts-params .dx-command-edit .dx-link-icon:last-child {
  margin-right: 0 !important;
}
</style>
